export default "__VITE_ASSET__BeePUkjv__"